<script lang="ts">
	import dayjs from 'dayjs';
	import timezone from 'dayjs/plugin/timezone';
	import utc from 'dayjs/plugin/utc';
	import AddToWatchlist from './AddToWatchlist.svelte';
	import { getSignedColor } from './utils';

	dayjs.extend(utc);
	dayjs.extend(timezone);

	interface Props {
		symbol: Populated<BaseSymbol, 'mutualFund'>;
		mutualFundQuote: MutualFundData;
	}

	let { symbol, mutualFundQuote }: Props = $props();

	let { name, mutualFund } = $derived(symbol);
</script>

<section class="mb-6">
	<h1 class="h1 text-green-dark mb-3">{name}</h1>
	<p class="body-regular text-gray-dark mb-3">
		Share Class : {mutualFund.shareClass}
	</p>
	<AddToWatchlist {symbol} />
	<div class="mt-3 flex items-center gap-2">
		<p class="text-3xl font-medium">
			{mutualFundQuote.regularMarketPrice.toLocaleString('default', {
				minimumFractionDigits: 3,
				maximumFractionDigits: 3
			})}
		</p>
		<p
			class="body-bold"
			style="color: var(--color-{getSignedColor(mutualFundQuote.regularMarketChangePercent)})"
		>
			{mutualFundQuote.regularMarketChangePercent.toLocaleString('default', {
				style: 'percent',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				signDisplay: 'exceptZero'
			})}
		</p>
	</div>
	<p class="small-regular text-gray-mid">
		NAV in {mutualFundQuote.currency}. As of {dayjs
			.utc(mutualFundQuote.regularMarketTime)
			.tz('Asia/Singapore', true)
			.format('HH:mm:ss')} SGT
	</p>
</section>
